function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import Modal from 'components/Modal';
import Form from 'components/Form';
import App from 'modules/App';
import * as actions from '../../actions';
import { CONNECT_DATA_SOURCE_MODAL, CONNECT_DATA_SOURCE_FORM } from '../../constants';
import messages from '../../messages';
import Actions from './Actions';
import Field from './Field';
import validatorRules from './validatorRules.json';
import styles from './ConnectDataSourceModal.pcss';
const ConnectDataSourceModal = ()=>{
    var _formValues_contextData, _localizationResources_nameKey;
    const openModalId = useSelector(App.selectors.modal);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const formValues = App.hooks.useFormValues(CONNECT_DATA_SOURCE_FORM);
    const dataSource = (formValues === null || formValues === void 0 ? void 0 : (_formValues_contextData = formValues.contextData) === null || _formValues_contextData === void 0 ? void 0 : _formValues_contextData.externalDataSource) || {};
    const closeModal = useAction(App.actions.closeModal);
    const clearForm = useAction(App.actions.clearForm, CONNECT_DATA_SOURCE_FORM);
    const connect = useAction(actions.connect, dataSource);
    useStyles(styles);
    const onClose = ()=>{
        closeModal();
        clearForm();
    };
    const submitForm = useCallback((dataSourceCredentials)=>{
        connect(dataSourceCredentials);
    }, [
        connect
    ]);
    const processForm = App.hooks.useFormProcessing(CONNECT_DATA_SOURCE_FORM, submitForm);
    const onSubmit = ()=>processForm(formValues, validatorRules);
    const { dataSourceProvider = '', nameKey = '', logo = '' } = dataSource;
    const dataSourceName = (localizationResources === null || localizationResources === void 0 ? void 0 : (_localizationResources_nameKey = localizationResources[nameKey]) === null || _localizationResources_nameKey === void 0 ? void 0 : _localizationResources_nameKey.value) || dataSourceProvider;
    const headerMessage = _object_spread_props(_object_spread({}, messages.headers.connectToDataSource), {
        values: {
            dataSourceName
        }
    });
    const introMessage = messages.intros.dataSource[dataSourceProvider];
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: CONNECT_DATA_SOURCE_MODAL,
        openModalId: openModalId,
        headerMessage: headerMessage,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx("figure", {
                className: "text--center mb-6",
                children: /*#__PURE__*/ _jsx("img", {
                    className: styles.externalDataSourceLogo,
                    src: logo,
                    alt: dataSourceName
                })
            }),
            introMessage && /*#__PURE__*/ _jsx("p", {
                className: "text--bold mb-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, introMessage))
            }),
            /*#__PURE__*/ _jsxs(Form, {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ _jsx(Field, {
                        id: "email"
                    }),
                    /*#__PURE__*/ _jsx(Field, {
                        id: "password"
                    }),
                    /*#__PURE__*/ _jsx(Actions, {
                        onClose: onClose
                    })
                ]
            })
        ]
    });
};
export default ConnectDataSourceModal;
